/** @jsx jsx */
import React from 'react'
import { config, useSpring } from 'react-spring'
import { jsx } from 'theme-ui'
import { TextOnTable } from '../../components'
import { IPokerChipStacksProps, PositionedPokerChipStacks } from '../../components/PokerChipStack'
import { Positioned } from '../../components/Positioned'
import { ClientGameHandController } from '../../controllers/ClientGameHandController'
import { ID, Model } from '../../sharedBetweenServerAndClient__DO_NOT_EDIT/types'
import { IPositionProps, IUserPositioning } from './positionProps'

export const UsersCurrentTableAction: React.FC<
  Pick<IPositionProps, 'measurements'> &
    Partial<IPokerChipStacksProps> & {
      userId: ID
      controller: ClientGameHandController
      previousController?: ClientGameHandController
    }
> = ({ userId, controller, previousController, measurements, ...props }) => {
  const isHandOver = !!controller.gameHand.finalResult
  const hasEndedPreviousRound =
    previousController &&
    controller.gameHand.id === previousController.gameHand.id &&
    controller.gameHand.bettingRounds.length !== previousController.gameHand.bettingRounds.length
  const shouldSlideTowardsMiddle = isHandOver || hasEndedPreviousRound
  const userData = hasEndedPreviousRound
    ? previousController!.getUserData(userId)
    : controller.getUserData(userId)
  const initialCoords = userData.calcPositionFromPixels(-70)
  const finalCoords = measurements.centerOfTable
  // @ts-ignore
  const { left, top, opacity } = useSpring({
    from: {
      left: initialCoords.left,
      top: initialCoords.top,
      opacity: 1,
    },
    to: {
      left: shouldSlideTowardsMiddle ? finalCoords.left : initialCoords.left,
      top: shouldSlideTowardsMiddle ? finalCoords.top : initialCoords.top,
      opacity: shouldSlideTowardsMiddle ? 0 : 1,
    },
    immediate: !shouldSlideTowardsMiddle,
    config: config.slow,
  })
  if (userData.state === 'FOLDED') {
    return (
      <Positioned height={24} width={40} coords={initialCoords}>
        <TextOnTable sx={{ fontSize: [1, null, null, 2] }}>Folded</TextOnTable>
      </Positioned>
    )
  }
  if (userData.amountInvestedInCurrentRound) {
    return (
      <PositionedPokerChipStacks
        amount={userData.amountInvestedInCurrentRound}
        coords={{ left, top }}
        style={{ opacity }}
        without={
          controller.gameHand.userTablePosition.length > 7 || !measurements.isLandscapeMode
            ? 'stacks'
            : undefined
        }
        {...props}
      />
    )
  }
  if (userData.lastActionThisRound?.type === 'CHECK') {
    if (shouldSlideTowardsMiddle) {
      return null
    }
    return (
      <Positioned height={24} width={40} coords={initialCoords}>
        <TextOnTable sx={{ fontSize: [1, null, null, 2] }}>Check</TextOnTable>
      </Positioned>
    )
  }
  if (userData.state === 'ALL_IN') {
    return (
      <Positioned height={24} width={40} coords={initialCoords}>
        <TextOnTable sx={{ fontSize: [1, null, null, 2] }}>All In</TextOnTable>
      </Positioned>
    )
  }
  if (userData.state === 'OUT') {
    return (
      <Positioned height={24} width={95} coords={initialCoords}>
        <TextOnTable sx={{ fontSize: [1, null, null, 2] }}>Out of game</TextOnTable>
      </Positioned>
    )
  }
  return null
}
